import PropTypes from 'prop-types';
import SportAndCountryIconImpl from './sport-and-country-icon.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Pair of leading icons shared by event cards. The country flag is badged onto the lower corner of
 * the sport icon, so that the two read as one mark at the head of a card. Renders nothing when both
 * icons are switched off, and drops the flag on its own for an event that carries no country.
 *
 * @class SportAndCountryIcon
 * @memberof Mojito.Presentation.Components
 */

/**
 * SportAndCountryIcon prop types.
 *
 * @property {string} sportId - Id of the sport to show the icon of.
 * @property {string} [countryCode] - Code of the country to show the flag of. The flag is left out when omitted.
 * @property {string} [countryName] - Name of the country, used as the alt text of the flag.
 * @property {string} [alt] - Alt text of the sport icon.
 *
 * @memberof Mojito.Presentation.Components.SportAndCountryIcon
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    countryCode: PropTypes.string,
    countryName: PropTypes.string,
    alt: PropTypes.string,
};

export default UIView('SportAndCountryIcon', SportAndCountryIconImpl, propTypes);
